// Trust bar: a quiet eyebrow and a slow logo marquee. Pauses on hover, static under
// reduced motion (the row simply sits centered).

interface Publication {
  name: string;
  logo: string;
  url: string;
  h: string; // Tailwind height class per logo to even out optical size
}

const publications: Publication[] = [
  { name: 'Forbes', logo: '/noted-in/forbes.svg', url: 'https://forbes.com', h: 'h-7 md:h-8' },
  {
    name: 'TechCrunch',
    logo: '/noted-in/tech-crunch.svg',
    url: 'https://techcrunch.com',
    h: 'h-5 md:h-6',
  },
  {
    name: 'CoinDesk',
    logo: '/noted-in/coindesk-logo.png',
    url: 'https://coindesk.com',
    h: 'h-7 md:h-8',
  },
  {
    name: 'Decrypt',
    logo: '/noted-in/decrypt-logo.svg',
    url: 'https://decrypt.co',
    h: 'h-5 md:h-6',
  },
  {
    name: 'a16z crypto',
    logo: '/noted-in/a16zcrypto.svg',
    url: 'https://a16zcrypto.com',
    h: 'h-5 md:h-6',
  },
];

function Logo({ pub }: { pub: Publication }) {
  const svg = pub.logo.endsWith('.svg');
  return (
    <a
      href={pub.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Visit ${pub.name}`}
      className="flex items-center shrink-0 px-10 md:px-14 opacity-60 hover:opacity-100 transition-opacity"
    >
      <img
        src={pub.logo}
        alt={pub.name}
        className={`${pub.h} w-auto object-contain ${svg ? 'brightness-0 invert' : ''}`}
        loading="lazy"
      />
    </a>
  );
}

export function FeaturedIn() {
  const row = [...publications, ...publications];
  return (
    <section className="pt-0 pb-6 md:pb-8 relative">
      <div className="max-w-5xl mx-auto px-4">
        <p className="text-white/50 font-medium uppercase text-xs tracking-[0.25em] mb-4">
          Clients featured in
        </p>
      </div>
      <div className="marquee relative overflow-hidden border-y border-white/10 py-4 md:py-5">
        <div className="marquee-track flex items-center w-max">
          {row.map((pub, i) => (
            <Logo key={`${pub.name}-${i}`} pub={pub} />
          ))}
        </div>
      </div>
    </section>
  );
}
